document.addEventListener('DOMContentLoaded',function(){
  var t=document.querySelector('.menu-toggle');
  var m=document.getElementById('bx-mobile-menu');
  var h=document.querySelector('.bx-shop-header');

  function positionMenu(){
    if(!m || !h) return;
    var bottom=Math.max(0,Math.round(h.getBoundingClientRect().bottom));
    m.style.top=bottom+'px';
    m.style.maxHeight='calc(100dvh - '+bottom+'px)';
  }

  function closeMenu(){
    if(!m || !t) return;
    m.classList.remove('is-open');
    t.setAttribute('aria-expanded','false');
    document.documentElement.classList.remove('bx-menu-open');
  }

  if(t&&m){
    t.addEventListener('click',function(){
      var opening=!m.classList.contains('is-open');
      if(opening){
        positionMenu();
        m.classList.add('is-open');
        t.setAttribute('aria-expanded','true');
        document.documentElement.classList.add('bx-menu-open');
      }else{
        closeMenu();
      }
    });

    m.querySelectorAll('a').forEach(function(link){
      link.addEventListener('click',closeMenu);
    });

    document.addEventListener('keydown',function(e){
      if(e.key==='Escape') closeMenu();
    });

    window.addEventListener('resize',function(){
      if(window.innerWidth>900){
        closeMenu();
      }else if(m.classList.contains('is-open')){
        positionMenu();
      }
    });

    window.addEventListener('scroll',function(){
      if(m.classList.contains('is-open')) positionMenu();
    },{passive:true});
  }
});
